export class VisibilityDto {
  constructor(dto) {
    this.name = dto.name;
    this.value = dto.value;
  }
}
